export default __webpack_public_path__ + "info-icon.svg";